import * as form from '../form';

export const identificationBirthplace = (data = {}) => ({
  Location: form.location(data.Location),
  MothersNameAtHerBirth: form.name(data.MothersNameAtHerBirth), // PVQ only
  MothersNameAtYourBirth: form.name(data.MothersNameAtYourBirth) // PVQ only
});
